import React, { memo, useMemo } from 'react';

import Group from './Group';

type Props = {
  groups: any[];
  pageNum: number;
};

function Groups({ groups, pageNum }: Props) {
  return (
    <>
      {groups.map((group) => (
        <Group key={group.GROUPNUM} group={group} pageNum={pageNum} />
      ))}
    </>
  );
}
export default memo(Groups);
